import { useEffect, type ReactNode } from 'react';
import { useNavigate } from '@tanstack/react-router';

import { modeForCategory, type PortalMode } from '../lib/mode';
import { useBusiness } from '../lib/useBusiness';

type RequireModeProps = {
  children: ReactNode;
  mode: PortalMode;
};

/**
 * Keeps category-specific tools out of unrelated portals when their URL is
 * entered directly. The API repeats this invariant for the writes themselves.
 */
export function RequireMode({ children, mode }: RequireModeProps) {
  const business = useBusiness();
  const navigate = useNavigate();
  const loaded = business !== undefined;
  const allowed = !loaded || modeForCategory(business.category) === mode;

  useEffect(() => {
    if (loaded && !allowed) {
      void navigate({ to: '/', replace: true });
    }
  }, [allowed, loaded, navigate]);

  if (loaded && !allowed) return null;
  return <>{children}</>;
}
